import {
  applyThemeConfig,
  getStoredThemeConfig,
  persistActiveThemeId,
  resolveThemeConfig,
  shellThemeStorageKey,
  type ThemeConfig
} from "./theme-engine";

export const shellThemes = ["light", "dark"] as const;

export type ShellTheme = (typeof shellThemes)[number];

export function isShellTheme(value: string | null): value is ShellTheme {
  return shellThemes.some((theme) => theme === value);
}

export function getStoredShellTheme(): ShellTheme {
  const storedTheme = localStorage.getItem(shellThemeStorageKey);

  return isShellTheme(storedTheme) ? storedTheme : "light";
}

export function applyShellTheme(theme: ShellTheme): void {
  applyThemeConfig(resolveThemeConfig(theme));
}

export function persistShellTheme(theme: ShellTheme): void {
  persistActiveThemeId(theme);
  applyShellTheme(theme);
}

export function applyStoredThemeConfig(): ThemeConfig {
  const config = getStoredThemeConfig();
  applyThemeConfig(config);

  return config;
}

export { shellThemeStorageKey };

export {
  applyThemeConfig,
  clearRuntimeThemeConfig,
  customThemeStorageKey,
  defaultThemeId,
  getAvailableThemeConfigs,
  getStoredThemeConfig,
  loadThemeConfigFromJson,
  persistActiveThemeId,
  persistThemeConfig,
  resolveThemeConfig,
  themeTokenAliases,
  type ThemeConfig,
  type ThemeConfigSummary,
  type ThemeTokenAlias
} from "./theme-engine";
